import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";

const DAY = 24 * 60 * 60 * 1000;
const MAX_LABELS = 8;

/** Day-scaled bar comparing the ijtima's span with the attendance access window. */
const AttendanceTimeline = ({ eventStart, eventEnd, start, end, invalid, labelClassName }) => {
  const { t } = useTranslation();

  const from = moment(Math.min(eventStart, start || eventStart)).startOf("day");
  const to = moment(Math.max(eventEnd, end || eventEnd))
    .add(1, "day")
    .startOf("day");
  const span = to.valueOf() - from.valueOf();
  const pct = (date) => ((date - from.valueOf()) / span) * 100;

  const days = Math.round(span / DAY);
  const labelStep = Math.ceil((days + 1) / MAX_LABELS);
  const boundaries = Array.from({ length: days + 1 }, (_, i) =>
    from.clone().add(i, "day"),
  );

  const now = Date.now();
  const showNow = now > from.valueOf() && now < to.valueOf();
  const hasWindow = start && end && end > start;

  return (
    <div className="aa-timeline" dir="ltr">
      <div className="aa-timeline-labels">
        {boundaries.map((d, i) =>
          i % labelStep === 0 ? (
            <span
              key={d.valueOf()}
              style={{ left: `${Math.min(96, Math.max(4, pct(d.valueOf())))}%` }}
            >
              {d.locale("en").format("DD MMM")}
            </span>
          ) : null,
        )}
      </div>
      <div className="aa-track">
        {boundaries.slice(1, -1).map((d) => (
          <i key={d.valueOf()} className="aa-tick" style={{ left: `${pct(d.valueOf())}%` }} />
        ))}
        <i
          className="aa-bar-event"
          style={{ left: `${pct(eventStart)}%`, width: `${pct(eventEnd) - pct(eventStart)}%` }}
        />
        {hasWindow && (
          <i
            className={`aa-bar-access${invalid ? " invalid" : ""}`}
            style={{ left: `${pct(start)}%`, width: `${pct(end) - pct(start)}%` }}
          />
        )}
        {showNow && <i className="aa-now" style={{ left: `${pct(now)}%` }} />}
      </div>
      <div className={`aa-legend ${labelClassName || ""}`}>
        <span>
          <i className="aa-legend-event" />
          {t("attendance_access_legend_ijtima")}
        </span>
        <span>
          <i className={`aa-legend-access${invalid ? " invalid" : ""}`} />
          {t("attendance_access_legend_access")}
        </span>
        {showNow && (
          <span>
            <i className="aa-legend-now" />
            {t("attendance_access_legend_now")}
          </span>
        )}
      </div>
    </div>
  );
};

export default AttendanceTimeline;
